import { render, staticRenderFns } from "./CustomerAddressModal.vue?vue&type=template&id=1cc66e93"
import script from "./CustomerAddressModal.vue?vue&type=script&lang=js"
export * from "./CustomerAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports